import * as React from 'react';
import { PromoFormBlock } from '@design-system/promo-form-block';
import { useStaticQuery, graphql } from 'gatsby';

import {
  getCurrentNodeByLocale,
  getHardcodedPathByLocaleCode,
  getProductsPageSlugByLocaleCode,
} from '../utils';

import { LOCALES } from '../constants';

import '../styles/footer.scss';

const Footer = ({ isProductSetPage, currentLocaleCode }) => {
  const data = useStaticQuery(staticQuery);

  const currentFooter = getCurrentNodeByLocale(data.allContentstackFooter.nodes, currentLocaleCode);
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
  const lengthHalf = Math.ceil(currentFooter.items.length / 2);

  const isProductPage =
    (currentPath.startsWith(getProductsPageSlugByLocaleCode(currentLocaleCode)) &&
      !currentPath.endsWith(getProductsPageSlugByLocaleCode(currentLocaleCode))) ||
    isProductSetPage;

  const currentHomePage = getHardcodedPathByLocaleCode('home', currentLocaleCode);
  const isHomepagePromoForm = currentPath === currentHomePage || isProductPage;

  return (
    <footer>
      <div className="w-full grid-cols-12">
        <div className="grid grid-cols-4 footer-items gap-y-8 md:gap-y-0 ">
          <div className="col-span-4 md:col-span-2 promo-form">
            <h2>
              {isHomepagePromoForm
                ? currentFooter.homepage_promo_form.title
                : currentFooter.promo_form.title}
            </h2>

            <p class="promo-form__required-text">{LOCALES.es.url === currentPath ? '* Campos obligatorios' : '* required fields'}</p>

            <PromoFormBlock
              url="https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms"
              formId={
                isHomepagePromoForm
                  ? currentFooter.homepage_promo_form.form_id
                  : currentFooter.promo_form.form_id
              }
              submitErrorMessage={
                isHomepagePromoForm
                  ? currentFooter.homepage_promo_form.submit_error_message
                  : currentFooter.promo_form.submit_error_message
              }
            />
          </div>
          <div className="links-column flex flex-col border-b pb-12 md:pb-0 md:border-none space-y-1 col-span-4 md:col-span-1">
            {currentFooter.items.slice(0, lengthHalf).map((item) => (
              <span key={item.text}>
                <a
                  className="footer-link"
                  href={item.url}
                  title={item.text}
                  aria-label={item.target === '_blank' ? `${item.text} opens in new window` : item.text}
                  target={item.target || '_self'}
                >
                  {item.text}
                </a>
              </span>
            ))}
            <div className="social">
              <p>{currentFooter?.title_social}</p>
              <ul className="social-icons flex flex-row space-x-4">
                <li><a
                  className="socialmedia__link socialmedia__link--instagram"
                  href="https://www.instagram.com/airwickus/"
                  aria-label='Instagram opens in a new tab'
                  target='_blank'
                >
                  <span className="socialmedia__link--text"></span>
                </a></li>
                <li><a
                  className="socialmedia__link socialmedia__link--twitter"
                  href="https://twitter.com/airwickus"
                  aria-label="Twitter opens in a new tab"
                  target='_blank'
                >
                  <span className="socialmedia__link--text"></span>
                </a></li>
                <li><a
                  className="socialmedia__link socialmedia__link--facebook"
                  href="https://www.facebook.com/AirWickUS"
                  aria-label="facebook opens in a new tab"
                  target='_blank'
                >
                  <span className="socialmedia__link--text"></span>
                </a></li>
                <li><a
                  className="socialmedia__link socialmedia__link--pinterest"
                  href="https://www.pinterest.com/airwickus/"
                  aria-label="pinterest opens in a new tab"
                  target='_blank'
                >
                  <span className="socialmedia__link--text"></span>
                </a></li>
                <li><a
                  className="socialmedia__link socialmedia__link--youtube"
                  href="https://www.youtube.com/user/AirWickUS"
                  aria-label="youtube opens in a new tab"
                  target='_blank'
                >
                  <span className="socialmedia__link--text"></span>
                </a></li>
              </ul>
            </div>
          </div>
          <div className="links-column flex flex-col space-y-1 col-span-4 md:col-span-1 border-b pb-12 md:pb-0 md:border-none ">
            {currentFooter.items.slice(lengthHalf).map((item) => (
              <span key={item.text}>
                <a
                  className="footer-link"
                  href={item.url}
                  title={item.text}
                  aria-label={item.target === '_blank' ? `${item.text} opens in new window` : item.text}
                  target={item.target || '_self'}
                >
                  {item.text}
                </a>
              </span>
            ))}
          </div>
          <span className="copyright">{currentFooter?.copyright}</span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;

const staticQuery = graphql`
  query {
    allContentstackFooter(
      filter: { domain_name: { eq: "airwick.us" }, locale: { in: ["en-es", "en-us"] } }
    ) {
      nodes {
        promo_form {
          title
          description
          form_id
          submit_error_message
        }
        homepage_promo_form {
          title
          description
          form_id
          submit_error_message
        }
        items {
          text
          url
          target
        }
        title_social
        copyright
        locale
      }
    }
  }
`;
